import RecommendCarianModal from './RecommendCarianModal';

export default RecommendCarianModal;
